/**
 * @generated SignedSource<<580d5c5477c5e97428a35f2989f7dcfe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetDefaultRelayTemplate$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly active: boolean;
      readonly docTemplatesTenants: ReadonlyArray<{
        readonly isDefault: boolean | null;
        readonly tenantId: string | null;
      } | null> | null;
      readonly id: string;
      readonly type: string;
    };
  } | null> | null;
  readonly " $fragmentType": "useGetDefaultRelayTemplate";
};
export type useGetDefaultRelayTemplate$key = {
  readonly " $data"?: useGetDefaultRelayTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetDefaultRelayTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetDefaultRelayTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DocTemplateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DocTemplate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DocTemplatesTenants",
              "kind": "LinkedField",
              "name": "docTemplatesTenants",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tenantId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefault",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DocTemplateConnection",
  "abstractKey": null
};

(node as any).hash = "d25d04a3594ebef05db460416be9569e";

export default node;
